export const interactiveWebglDemo2023Gql = `... on landingPageContent2023_interactiveWebglDemo_BlockType{
	typeHandle
	title
	demoEntry(limit:1) {
		slug
	}
}`;
